<template>
    <div class="libs-body">
        <TopBar />
        
        <div class="libs-content">
            <a-spin :spinning="libLoading">
            <div style="background-color: #F5F5F5;height: 62px;">
                <a-breadcrumb style="height: 22;padding-top: 24px;padding-left:24px;">
                    <a-breadcrumb-item><a href="/#" >Clearance</a></a-breadcrumb-item>
                    <a-breadcrumb-item>Compl-Libs</a-breadcrumb-item>
                </a-breadcrumb>
            </div>
            <div class="title-cls" style="margin-left: 24px; margin-right: 24px; margin-top: 16px;">
                <div>
                    <label style="font-size: 16px;font-weight: 600;line-height: 22px;">Compliance Library</label>    
                </div>
                <div class="tabs-cls" style="margin-top: 16px;display: flex;">
                    <div style="flex : 1;">
                        <a-segmented v-model:value="libsType" :options="libsOptions" size="large" @change="segmentChange">
                            <template #label="{ payload = {} }">
                                <div class="seg-tabs" style="display: flex;margin: 4px 16px 4px 16px;justify-content: center;">
                                    <div style="width: 16px;height: 16px;"><component :is="payload.icon"/></div>
                                    <div style="margin-left: 6px;font-size: 16px;font-weight: 400;">{{ payload.label }}</div>
                                </div>
                            </template>
                        </a-segmented>
                    </div>
                    <div>
                        <a-input-search v-model:value="searchValue" placeholder="Search" style="width:240px" @search="searchHandle" size="large" allowClear />
                    </div>
                </div>
            </div>
            
            <div class="libs-detail" style="margin-left: 24px;margin-right:24px; margin-top : 24px">
                <div v-if="libsType === 'PGA'">
                    <PGALibs ref="PGARef" @load_event="show_loading"/>
                </div>
                <!-- <div v-else-if="libsType === 'description' ">
                    <VangeLibs ref="VangeRef" @load_event="show_loading" />
                </div> -->
                <div v-else-if="libsType === 'rules'">
                    <RuleLibs ref="RuleRef" @load_event="show_loading" />
                </div>
            </div>
            </a-spin>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from 'vue'
import Api from '@/api/Api'
import TopBar from '@/components/TopBar.vue'
import route from "@/router"
import pgaData from "@/pga-data.json"
import { AppstoreOutlined, BlockOutlined,IdcardOutlined } from "@ant-design/icons-vue"
import VangeIcon from '@/components/Icons/VangeIcon.vue'
import PGALibs from '@/components/PGALibs.vue'
//import VangeLibs from '@/components/VangeLibs.vue'
import RuleLibs from '@/components/RuleLibs.vue'

export default defineComponent({
    name : "libs",
    components :{
        TopBar,
        AppstoreOutlined,
        BlockOutlined,
        VangeIcon,
        IdcardOutlined,
        PGALibs,
        //VangeLibs,
        RuleLibs
    },
    setup() {
        const PGARef = ref()
        //const VangeRef = ref()
        const RuleRef = ref()
        const libLoading = ref(false)
       
        const libsOptions = [
            {
                value : 'PGA',
                payload: {
                    label : "PGA Lib",
                    icon: AppstoreOutlined
                } 
            },
            // {
            //     value : "description",
            //     payload :{
            //         label : "Description Lib",
            //         icon: VangeIcon
            //     }
            // },
            {
                value : "rules",
                payload :{
                    label : "Rules Lib",
                    icon : BlockOutlined
                }
            },
            // {
            //     value : "hts",
            //     disabled : true,
            //     payload :{
            //         label : "HTS Code Lib",
            //         icon : IdcardOutlined
            //     }
            // }
        ]
        
        const libsType = ref(libsOptions[0].value)
        const searchValue = ref("")

        const show_loading = (b : boolean) =>{
            libLoading.value = b
        }

        const searchHandle = () =>{
            
            if( libsType.value === libsOptions[0].value){
                if( PGARef && PGARef.value) {
                    //console.log(PGARef.value)
                    PGARef.value.search(searchValue.value)
                } 
            }
            
            // if( libsType.value === libsOptions[1].value){
            //     if(VangeRef && VangeRef.value){
            //         VangeRef.value.search(searchValue.value)
            //     }
            // }

            if( libsType.value === libsOptions[1].value){
                if(RuleRef && RuleRef.value){
                    RuleRef.value.search(searchValue.value)
                }
            }            
        }

        const segmentChange = () =>{
            searchValue.value = ""
        }
        return {
            libLoading,
            libsOptions,
            libsType,
            searchValue,
            show_loading,
            searchHandle,
            PGARef,
            //VangeRef,
            RuleRef,
            segmentChange
        }
    }
})
</script>
<style scoped>
.libs-body {
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    background: #F5F5F5;
}
.libs-content {
    background-color: #FFFFFF;
    margin: 0px 24px 24px 24px;
    height: -webkit-fill-available;
}

:deep(.tabs-cls .ant-segmented-item-selected) {
    color: #1677ff;
    :deep(svg){
        fill: #1677ff;
    };
}

</style>